import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { ScrollManager } from "@/components/ScrollManager";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Calculadora from "@/pages/Calculadora";
import ProductDetail from "@/pages/ProductDetail";
import CatalogoBestSellers from "@/pages/CatalogoBestSellers";
import SeguimientoPedido from "@/pages/SeguimientoPedido";

function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <ConfigProvider>
                <BrowserRouter>
                    <SmoothScroll>
                        <ScrollManager />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/tienda" element={<Catalog />} />
                            <Route path="/producto/:id" element={<ProductDetail />} />
                            <Route path="/calculadora" element={<Calculadora />} />
                            <Route path="/catalogo" element={<CatalogoBestSellers />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/pedido-exitoso" element={<OrderSuccess />} />
                            <Route path="/pedido/:orderNumber" element={<SeguimientoPedido />} />
                            <Route path="/padmin" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                        </Routes>
                    </SmoothScroll>
                </BrowserRouter>
                </ConfigProvider>
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: { background: "#0B2B1B", color: "#F4F4F0", border: "1px solid #C5A059", borderRadius: 0 },
                    }}
                />
            </CartProvider>
        </AuthProvider>
    );
}

export default App;
